import React from 'react';
import { useToggle } from '~/helpers/data';
import RawHTML from '~/components/jsx-helpers/raw-html';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay } from '@fortawesome/free-solid-svg-icons/faPlay';
import Dialog from '~/components/dialog/dialog';
import ResourceBox from './resource-box';
export default function VideoResourceBoxes({ models, blogLinkModels, referenceModels }) {
    return (React.createElement(React.Fragment, null,
        models.map((model) => (React.createElement(VideoResourceBox, { model, key: model.videoFile }))), blogLinkModels === null || blogLinkModels === void 0 ? void 0 :
        blogLinkModels.map((model) => (React.createElement(ResourceBox, { model: model, key: model.heading }))), referenceModels === null || referenceModels === void 0 ? void 0 :
        referenceModels.map((model) => (React.createElement(ResourceBox, { model: model, key: model.heading })))));
}
function VideoResourceBox({ model }) {
    const [isOpen, toggle] = useToggle(false);
    const doToggle = React.useCallback((event) => {
        event.preventDefault();
        toggle();
    }, [toggle]);
    return (React.createElement("div", { className: 'video resource-box', onClick: doToggle, key: model.resourceHeading },
        React.createElement("div", null,
            React.createElement("div", { className: 'top-line' },
                React.createElement("h3", null, model.resourceHeading)),
            React.createElement(RawHTML, { className: 'description', html: model.resourceDescription }),
            React.createElement("video", { controls: true, preload: 'metadata' },
                React.createElement("source", { src: model.videoFile, type: 'video/avi' }))),
        React.createElement(BottomBasic, { model: model, leftContent: 'Watch video', icon: faPlay }),
        React.createElement(Dialog, { isOpen: isOpen, onPutAway: toggle, title: model.videoTitle || model.resourceHeading },
            React.createElement(ResourceVideoViewer, { file: model.videoFile }))));
}
function VideoViewer({ file }) {
    return (React.createElement("div", { className: 'aspect-16-by-9-container' },
        React.createElement("video", { controls: true, src: file })));
}
function ResourceVideoViewer(args) {
    return (React.createElement("div", { className: 'instructor-resource-video-viewer' },
        React.createElement(VideoViewer, Object.assign({}, args))));
}
function BottomBasic({ leftContent, icon, model }) {
    return (React.createElement("div", { className: 'bottom' },
        React.createElement("a", { className: 'left', "data-analytics-select-content": model.heading, "data-content-type": `Book Resource (${model.resourceCategory})` },
            React.createElement(FontAwesomeIcon, { icon: icon }),
            leftContent)));
}
